import { makeStyles } from '@material-ui/styles'

import fontRegularEot from 'assets/fonts/UNL.eot'
import fontRegularOtf from 'assets/fonts/UNL.otf'
import fontRegularSvg from 'assets/fonts/UNL.svg'
import fontRegularTtf from 'assets/fonts/UNL.ttf'
import fontRegularWoff from 'assets/fonts/UNL.woff'
import fontRegularWoff2 from 'assets/fonts/UNL.woff2'

import fontBoldEot from 'assets/fonts/UNB.eot'
import fontBoldOtf from 'assets/fonts/UNB.otf'
import fontBoldSvg from 'assets/fonts/UNB.svg'
import fontBoldTtf from 'assets/fonts/UNB.ttf'
import fontBoldWoff from 'assets/fonts/UNB.woff'
import fontBoldWoff2 from 'assets/fonts/UNB.woff2'

export default makeStyles(() => ({
  '@font-face': [
    {
      fontFamily: 'Univers',
      src: `
        url("${fontRegularEot}"),
        url("${fontRegularEot}?#iefix") format("embedded-opentype"), 
        url("${fontRegularOtf}") format("opentype"), 
        url("${fontRegularSvg}") format("svg"), 
        url("${fontRegularTtf}") format("truetype"), 
        url("${fontRegularWoff}") format("woff"), 
        url("${fontRegularWoff2}") format("woff2"); 
      `
    },
    {
      fontFamily: 'Univers',
      src: `
        url("${fontBoldEot}"),
        url("${fontBoldEot}?#iefix") format("embedded-opentype"), 
        url("${fontBoldOtf}") format("opentype"), 
        url("${fontBoldSvg}") format("svg"), 
        url("${fontBoldTtf}") format("truetype"), 
        url("${fontBoldWoff}") format("woff"), 
        url("${fontBoldWoff2}") format("woff2"); 
      `,
      fontWeight: 'bold'
    }
    // {
    //   fontFamily: 'dinPro',
    //   src: `url(${fontBold}) format("opentype"), url(${fontBoldEot}) format("embedded-opentype")`,
    //   fontWeight: 'bold'
    // }
  ]
}))

/*

@font-face {
  font-family: "UniversBold";
  src: url("./fonts/UNB.eot");
  src: url("./fonts/UNB.eot?#iefix") format("embedded-opentype"),
    url("./fonts/UNB.otf") format("opentype"),
    url("./fonts/UNB.svg") format("svg"),
    url("./fonts/UNB.ttf") format("truetype"),
    url("./fonts/UNB.woff") format("woff"),
    url("./fonts/UNB.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}


@font-face {
  font-family: "UniversRegular";
  src: url("./fonts/UNL.eot");
  src: url("./fonts/UNL.eot?#iefix") format("embedded-opentype"),
    url("./fonts/UNL.otf") format("opentype"),
    url("./fonts/UNL.svg") format("svg"),
    url("./fonts/UNL.ttf") format("truetype"),
    url("./fonts/UNL.woff") format("woff"),
    url("./fonts/UNL.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}

*/
